<template>
  <div class="api-user-configuration-flow">
    <!-- API User Configuration -->
    <VasionGeneralModal
      id="configuration"
      modalType="slot"
      :sync="showApiUserConfigDialog"
      :hideButtons="true"
    >
      <APIUserConfiguration
        :apiUserId="apiUserId"
        @showSnackbarWithMessage="showSnackbarWithMessage"
        @close-and-refresh="closeAndRefresh"
        @open-tokens-list="openTokensList"
        @cancel="cancelFlow"
      />
    </VasionGeneralModal>
    <!-- API User Tokens List -->
    <VasionGeneralModal
      id="tokens-list"
      modalType="slot"
      :sync="showApiUserTokensListDialog"
      :hideButtons="true"
    >
      <APIUserTokensList
        :apiUser="apiUser"
        @open-generate-token-form="openGenerateTokenForm"
        @cancel="cancelFlow"
      />
    </VasionGeneralModal>
    <!-- API User Create Token -->
    <VasionGeneralModal
      id="generate-token-form"
      modalType="slot"
      :sync="showGenerateTokenFormDialog"
      :hideButtons="true"
    >
      <APIUserCreateToken
        :apiUser="apiUser"
        @back-to-api-tokens="backToAPITokens"
        @cancel="cancelFlow"
        @open-token="openToken"
      />
    </VasionGeneralModal>
    <!-- API User Token -->
    <VasionGeneralModal
      id="token"
      modalType="slot"
      :sync="showTokenDialog"
      :hideButtons="true"
    >
      <APIUserToken
        :token="token"
        @back-to-api-tokens="backToAPITokens"
        @cancel="cancelFlow"
        @done="backToAPITokensFromToken"
      />
    </VasionGeneralModal>
    <VasionSnackbar
      id="snackbar-api-user-configuration-flow"
      ref="snackbarApiUserConfigurationFlow"
      :showSnackbarBool.sync="showSnackbar"
      :snackbarImage="snackbarImage"
      :snackbarSubTitle="snackbarSubTitle"
      :snackbarTitle="snackbarTitle"
    />
  </div>
</template>
<script>
import APIUserConfiguration from '@/components/security/APIUserConfiguration.vue'
import APIUserTokensList from '@/components/security/APIUserTokensList.vue'
import APIUserCreateToken from '@/components/security/APIUserCreateToken.vue'
import APIUserToken from '@/components/security/APIUserToken.vue'

export default {
  name: 'APIUserConfigurationFlow',
  components: {
    APIUserConfiguration,
    APIUserTokensList,
    APIUserCreateToken,
    APIUserToken,
  },
  props: {
    apiUserId: {
      type: Number,
      default: 0,
      required: false,
    },
    state: {
      type: String,
      default: 'configuration',
      required: false,
    },
  },
  data: function () {
    return {
      apiUser: {},
      currentState: '',
      flowStates: ['configuration', 'tokensList', 'createToken', 'token'],
      showApiUserConfigDialog: false,
      showApiUserTokensListDialog: false,
      showGenerateTokenFormDialog: false,
      showTokenDialog: false,
      showSnackbar: false,
      snackbarImage: false,
      snackbarSubTitle: '',
      snackbarTitle: '',
      token: '',
    }
  },
  beforeDestroy() {
    this.token = ''
  },
  async created() {
    if (this.state === 'tokenList' && this.apiUserId > 0) {
      const apiUser = await this.$store.dispatch(
        'security/getUserDetails',
        this.apiUserId
      )
      this.apiUser = apiUser
      this.resetState(1)
      this.showApiUserTokensListDialog = true
      return
    }
    this.currentState = this.flowStates[0]
    this.showApiUserConfigDialog = true
  },
  methods: {
    backToAPITokens() {
      this.resetState(1)
      this.showApiUserTokensListDialog = true
    },
    backToAPITokensFromToken() {
      this.token = ''
      this.resetState(1)
      this.showApiUserTokensListDialog = true
    },
    cancelFlow() {
      this.resetState()
      this.$emit('close')
    },
    closeAndRefresh() {
      this.resetState()
      this.showApiUserConfigDialog = false
      this.$emit('refresh-main-table')
    },
    hideSnackbar() {
      this.showSnackbar = false
      this.snackbarImage = false
      this.$refs.snackbarApiUserConfigurationFlow.closeSnackbar()
    },
    openTokensList(apiUser) {
      this.$emit('refresh-table')
      this.apiUser = apiUser
      this.resetState(1)
      this.showApiUserTokensListDialog = true
    },
    openGenerateTokenForm(apiUser) {
      this.apiUser = apiUser
      this.resetState(2)
      this.showGenerateTokenFormDialog = true
    },
    openToken(token) {
      this.token = token
      this.resetState(3)
      this.showTokenDialog = true
    },
    resetState(stateIndex = 0) {
      this.showApiUserConfigDialog = false
      this.showApiUserTokensListDialog = false
      this.showGenerateTokenFormDialog = false
      this.showTokenDialog = false

      this.currentState = this.flowStates[stateIndex]
    },
    showSnackbarWithMessage(title, message, error = true) {
      this.snackbarTitle = title
      this.snackbarSubTitle = message
      this.snackbarImage = !error
      this.showSnackbar = true
    },
  },
}
</script>
